import { appConfig } from '../../../../appConfig';

export const buildAllProductResultsUrl = (query?: string, originalQuery?: string) => {
    const { url } = appConfig.coopSettings.ecommerce.search;
    const searchQuery = new URLSearchParams();
    if (query) {
        searchQuery.set('q', query);
    }

    if (originalQuery && originalQuery !== query) searchQuery.set('oq', originalQuery);

    return `${url}?${searchQuery.toString()}`;
};
